import { Marker } from "react-leaflet";
import pointUtilities from "../../utilities/pointUtilities";
import { divIcon } from "leaflet";
import stringUtilities from "../../utilities/stringUtilities";
import DataPopup from "./dataPopup";
import WhenMapIsNotDrawingOrEditing from "./whenMapIsNotDrawingOrEditing";
import { useEffect, useState } from "react";
import postal from "postal";
import arrayUtilities from "../../utilities/arrayUtilities";
import geospatialUtilities from "../../utilities/geospatialUtilities";
import snapUtilities from "../../utilities/snapUtilities";
import ConfigurationDialog from "./drawingTools/_configurationDialog";
import RotationSlider from "../form/rotationSlider";
import { EditMapFeature } from "../common/formsCreateEdit/editMapFeature";
import enums from "../../utilities/enums";
import { MoveData } from "../common/formsCreateEdit/moveData";
import useApi from "../../utilities/useApi";
import roleUtilities from "../../utilities/roleUtilities";
import { Button, Form, Modal } from 'react-bootstrap';
import SimpleBar from 'simplebar-react'
import { DELETED_DATA_OPACITY_FACTOR } from "../../utilities/constants";
import DataBuffer, { getBufferRadiusMeters } from "./dataBuffer";
import DataCpmDot from "./dataCpmDot";
import { LINE_EDIT_SKETCH_DATA_POSTAL_TOPIC, LINE_HOVER_POSTAL_TOPIC, hideLineVertices, showLineVertices } from "./lineHover";

export default function DataPoint(props) {
    const { api } = useApi();
    const [isNormallyVisible, setIsNormallyVisible] = useState(false);
    const [printingSketchLimitIndex, setPrintingSketchLimitIndex] = useState(null);
    const [printingWorkflowId, setPrintingWorkflowId] = useState(null);
    const [normallyVisibleWorkflowIds, setNormallyVisibleWorkflowIds] = useState(null);
    const [shouldPrint, setShouldPrint] = useState(true);
    const [isEditingSketchData, setIsEditingSketchData] = useState(false);
    const [isEditingFeature, setIsEditingFeature] = useState(false);
    const [isMovingData, setIsMovingData] = useState(false);
    const [rotate, setRotate] = useState(null);
    const [selectedProject, setSelectedProject] = useState(null);
    const [jobs, setJobs] = useState(props.jobs);
    const [workflowsByProject, setWorkflowsByProject] = useState(props.workflows);
    const [selectedJob, setSelectedJob] = useState(null);
    const [selectedWorkflow, setSelectedWorkflow] = useState(props.point.workflowId)
    const [selectedFeatureType, setSelectedFeatureType] = useState(props.point.formData.Type);
    const [featureTypes, setFeatureTypes] = useState(null);
    const [featureFormDataFields, setFeatureFormDataFields] = useState(null);
    const [featureFormDataValues, setFeatureFormDataValues] = useState(props.point.formData);
    const [isLoadingJobs, setIsLoadingJobs] = useState(false)
    const [isLoadingWorkflows, setIsLoadingWorkflows] = useState(false)
    const [showJobModal, setShowJobModal] = useState(false);
    const [newJobName, setNewJobName] = useState("");
    const [isLineHovered, setIsLineHovered] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [mixedValueFields, setMixedValueFields] = useState([]);
    const [linePointCount, setLinePointCount] = useState(0);
    const [showApplyToModal, setShowApplyToModal] = useState(false);
    const isLineVertex = !stringUtilities.isNullOrEmpty(props.point?.lineId);
    const isVisible = props.point && props.point !== null && (isLineVertex
        ? (props.workflowPointsLines?.includes(props.point.workflowId) || isLineHovered || isPopupOpen)
        : (props.isPreview || props.workflowPoints?.includes(props.point.workflowId)));
    const isDialogOpen = isEditingSketchData || isEditingFeature || isMovingData || showJobModal || showApplyToModal;
    const initialiseFormDataFields = (workflow, point) => {
        const parsedConfig = JSON.parse(workflow.configuration);
        let allFeatureTypes = [];
        ["types", "types2"].forEach(item => {
            const value = parsedConfig[item]
            if (!arrayUtilities.isNullOrEmpty(value)) {
                const featuresByGeometry = value.filter(item => (item.hasOwnProperty("geometryType") ? item.geometryType : "Point") === enums.GeometryType[point.geometryType === 0 && !stringUtilities.isNullOrEmpty(point.lineId) ? 1 : point.geometryType])
                allFeatureTypes.push(...featuresByGeometry);
            }
        })
        setFeatureTypes(allFeatureTypes);
        const formFieldsObject = allFeatureTypes.find(item => item.name === point.formData.Type);
        if (formFieldsObject !== undefined) {
            return formFieldsObject.fields
        }
    }

    const reset = function () {
        setRotate(0);

        if (!arrayUtilities.isNullOrEmpty(props.sketch?.configuration?.data)) {
            let dataItem = props.sketch.configuration.data.find(x => x.id === props?.point?.id);
            if (dataItem && dataItem !== null) {
                setRotate(dataItem.rotate);
            }
        }

        setFeatureFormDataValues(props.point.formData);

        const workflow = props.workflows.find(item => item.id === props.point.workflowId);
        if (!stringUtilities.isNullOrEmpty(workflow?.configuration)) {
            setFeatureFormDataFields(initialiseFormDataFields(workflow, props.point))
        } else {
            setFeatureTypes(null);
            setFeatureFormDataFields(null);
        };
        setSelectedProject(props.projectId);
        setJobs(props.jobs);
        setWorkflowsByProject(props.workflows);
        setSelectedJob(null);
        setSelectedWorkflow(props.point.workflowId);
        setSelectedFeatureType(props.point.formData.Type);
    }

    const onCancel = function () {
        setIsEditingSketchData(false);
        setIsEditingFeature(false);
        setIsMovingData(false);
        reset();
    }

    const onSave = function () {
        if (props.onSave) {
            props.onSave({
                id: props.point.id,
                rotate
            });
        }

        setIsEditingSketchData(false);
    }

    const onSavePointAttributes = () => {
        if (isLineVertex) {
            setShowApplyToModal(true);
            return;
        }

        savePointAttributes(true);
    }

    const savePointAttributes = (applyToLine) => {
        if (!props.sketch && props.onSavePointAttributes) {
            props.onSavePointAttributes(featureFormDataValues, props.point.id, selectedWorkflow, applyToLine)
        }
        setShowApplyToModal(false);
        setIsEditingFeature(false);
    }


    const isNormallyVisibleForWorkflowId = function (workflowId) {
        if (stringUtilities.isNullOrEmpty(workflowId)) {
            return false;
        }

        let typeIsNormallyVisible = pointUtilities.getType(props.point.workflowId, props.point.formData?.Type, props.workflows, false)?.isNormallyVisible ?? false;
        if (!typeIsNormallyVisible) {
            return false;
        }

        return normallyVisibleWorkflowIds?.includes(props.point.workflowId) ?? false;
    }

    useEffect(() => {

        let isNormallyVisible = isNormallyVisibleForWorkflowId(printingWorkflowId);
        setIsNormallyVisible(isNormallyVisible);

        if (isVisible || isNormallyVisible) {
            let shouldPrint = true;

            if ((printingSketchLimitIndex !== null) || !stringUtilities.isNullOrEmpty(printingWorkflowId)) {

                let workflow = arrayUtilities.isNullOrEmpty(props.workflows) ? null : props.workflows.find(x => x.id === props.point.workflowId);

                if (!stringUtilities.isNullOrEmpty(printingWorkflowId) && printingWorkflowId !== "ALL" && printingWorkflowId !== props.point.workflowId && (!workflow || workflow === null || !workflow.isComposite) && !isNormallyVisible) {
                    shouldPrint = false;
                }

                if (shouldPrint && printingSketchLimitIndex !== null && !isNaN(printingSketchLimitIndex) && props.sketch && props.sketch !== null && !arrayUtilities.isNullOrEmpty(props.sketch.limits) && props.sketch.limits.length > printingSketchLimitIndex) {
                    let limit = props.sketch.limits[printingSketchLimitIndex];

                    if (limit !== null) {
                        let polygon = workflow.isComposite ?
                            (!arrayUtilities.isNullOrEmpty(limit.limitOfSketchCoords) ? geospatialUtilities.boundsToPolygonCoords(limit.limitOfSketchCoords) : null) :
                            (!arrayUtilities.isNullOrEmpty(limit.limitOfLocateCoords) ? limit.limitOfLocateCoords : null);

                        if (polygon !== null && !geospatialUtilities.polygonContainsPoint(polygon, props.point)) {
                            shouldPrint = false;
                        }
                    }
                }
            }

            setShouldPrint(shouldPrint);
        }

    }, [printingSketchLimitIndex, printingWorkflowId])


    useEffect(() => {
        reset();
    }, [props.sketch])

    useEffect(() => {
        reset();
        const subscriptions = [
            postal.subscribe({
                channel: "map",
                topic: "printing",
                callback: function (data) {
                    setPrintingSketchLimitIndex(data.sketchLimitIndex);
                    setPrintingWorkflowId(data.workflowId);
                    setNormallyVisibleWorkflowIds(data.normallyVisibleWorkflowIds ?? null);
                }
            }),
        ]
        if (isLineVertex) {
            subscriptions.push(postal.subscribe({
                channel: "map",
                topic: LINE_HOVER_POSTAL_TOPIC,
                callback: function (data) {
                    setIsLineHovered(data.lineId === props.point.lineId);
                }
            }));
        }
        setSelectedProject(props.projectId)
        setSelectedWorkflow(props.point.workflowId);
        setSelectedFeatureType(props.point.formData.Type);
        const workflow = props.workflows.find(item => item.id === props.point.workflowId);
        if (!stringUtilities.isNullOrEmpty(workflow?.configuration)) {
            setFeatureFormDataFields(initialiseFormDataFields(workflow, props.point))
        } else {
            setFeatureTypes(null);
            setFeatureFormDataFields(null);
        };

        return () => {
            subscriptions.forEach(subscription => {
                subscription.unsubscribe();
            });
        }
    }, []);

    useEffect(() => {
        if (!stringUtilities.isNullOrEmpty(selectedWorkflow)) {

            const workflow = (isEditingFeature ? props.workflows : workflowsByProject).find(item => item.id === selectedWorkflow);
            if (!stringUtilities.isNullOrEmpty(workflow?.configuration)) {
                setFeatureFormDataFields(initialiseFormDataFields(workflow, props.point))
            } else {
                setFeatureTypes(null);
                setFeatureFormDataFields(null);
            };
        } else {
            setFeatureTypes(null);
            setFeatureFormDataFields(null);
        };
    }, [selectedWorkflow])

    useEffect(() => {
        if (featureTypes) {
            const temp = featureTypes.find(item => {
                if (item.name && item.name === selectedFeatureType) {
                    return item;
                }
            });
            if (temp !== undefined) {
                setFeatureFormDataFields(temp.fields);
            };
            setFeatureFormDataValues({ Type: selectedFeatureType })
        }

    }, [selectedFeatureType])

    const handleProjectChange = (id) => {
        setSelectedFeatureType(null);
        setSelectedWorkflow("");
        setSelectedProject(id)
        setSelectedJob(null);
        setIsLoadingJobs(true);
        setIsLoadingWorkflows(true);
        api.getJobs(props.organisationId, id, data => { setJobs(data); setIsLoadingJobs(false) }, error => console.log(error));
        api.getWorkflows(props.organisationId, id, data => { setWorkflowsByProject(data); setIsLoadingWorkflows(false) }, error => console.log(error))
    }

    const handleMoveData = () => {
        if (props.onMoveData) {
            props.onMoveData(props.projectId, props.point.id, selectedProject, selectedJob, selectedWorkflow, featureFormDataValues)
        }
        setIsMovingData(false);
    }

    const isFeatureShown = (isVisible || isNormallyVisible) && shouldPrint;

    if (isFeatureShown || isDialogOpen) {
        let iconUrl = pointUtilities.getIconUrlFromPoint(props.point, props.workflows);
        let color = pointUtilities.getColorFromPoint(props.point, props.workflows);
        let icon = isLineVertex ? divIcon({
            html: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="filter: drop-shadow(0 0 3px ${color})"><circle cx="12" cy="12" r="7" fill="${color}" stroke="#ffffff" stroke-width="2" fill-opacity="${props.point.isDeleted ? DELETED_DATA_OPACITY_FACTOR : 1}" /></svg>`,
            className: "marker-icon-point",
            iconAnchor: [12, 12],
            iconSize: [24, 24]
        }) : stringUtilities.isNullOrEmpty(iconUrl) ? divIcon({
            html: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" fill="${color}" fill-opacity="${props.point.isDeleted ? DELETED_DATA_OPACITY_FACTOR : 1}" /></svg>`,
            className: "marker-icon-point",
            iconAnchor: [8, 8],
            iconSize: [16, 16]
        }) : divIcon({
            html: `<img src="${iconUrl}" style="transform: rotate(${rotate ?? 0}deg); opacity: ${props.point.isDeleted ? DELETED_DATA_OPACITY_FACTOR : 1}">`,
            className: "marker-icon-point",
            iconAnchor: [15 * props.symbolScale, 15 * props.symbolScale],
            iconSize: [30 * props.symbolScale, 30 * props.symbolScale]
        });
        const canEdit = props.sketch && props.sketch !== null && (roleUtilities.hasOrgAdminCapability(props.user) || roleUtilities.isCollectorOrEditor(props.user))

        const popup = <WhenMapIsNotDrawingOrEditing>
                    <DataPopup
                        onUndeleteGeometry={undeleteMode => {
                            if (!stringUtilities.isNullOrEmpty(props.point.lineId) && undeleteMode === 1) {
                                props.handleUnDeleteGeometry(props.point.lineId)
                            } 
                        }}
                        onDeleteData={deleteMode => props.handleDelete(props.point.id, deleteMode)}
                        onUndeleteData={() => props.handleUnDelete(props.point)}
                        showConnectOption
                        connectionOriginalPoint={props.connectionOriginalPoint}
                        onClickConnect={point => props.handleConnectClick(point)}
                        isPreview={props.isPreview}
                        point={props.isPreview ? props.point : null}
                        organisationId={props.organisationId}
                        user={props.user}
                        canEdit={canEdit}
                        onEdit={() => isLineVertex
                            ? postal.publish({ channel: "map", topic: LINE_EDIT_SKETCH_DATA_POSTAL_TOPIC, data: { lineId: props.point.lineId } })
                            : setIsEditingSketchData(true)}
                        projectId={props.projectId}
                        pointId={props.point.id}
                        canDeletePoint
                        canDeleteGeometry={props.point.lineId && props.point.lineId !== null}
                        geometryType={props.point.geometryType}
                        onEditFeature={(point) => {
                            setMixedValueFields(point?.mixedValueFields ?? []);
                            setLinePointCount(point?.linePointCount ?? 0);
                            setIsEditingFeature(true);
                        }}
                        onMoveData={(point) => {
                            setIsMovingData(true)
                            setSelectedJob(jobs.find(item => item.name === point.job).id)
                        }}
                        sketch={props.sketch}
                    />
                </WhenMapIsNotDrawingOrEditing>;

        let zIndexOffset = 0;
        if (props.cpmDrawingOrder) {
            zIndexOffset = Math.min(Math.round(pointUtilities.getCpm(props.point)), 2000000) * 1000;
        }

        const isCpmDot = props.cpmDrawingOrder && stringUtilities.isNullOrEmpty(iconUrl) && stringUtilities.isNullOrEmpty(props.point.lineId) && pointUtilities.hasCpm(props.point);

        let feature;
        if (isLineVertex) {
            feature = <Marker position={{ lat: props.point.lat, lng: props.point.lng }} icon={icon} pointId={props.point.id} zIndexOffset={zIndexOffset}
                eventHandlers={{
                    mouseover: () => showLineVertices(props.point.lineId),
                    mouseout: () => hideLineVertices(),
                    popupopen: () => setIsPopupOpen(true),
                    popupclose: () => setIsPopupOpen(false)
                }}>{popup}</Marker>;
        } else if (getBufferRadiusMeters(props.point) !== null) {
            feature = <DataBuffer point={props.point} color={color} order={props.index}>{popup}</DataBuffer>;
        } else if (isCpmDot) {
            feature = <DataCpmDot point={props.point} color={color} order={props.index}>{popup}</DataCpmDot>;
        } else {
            feature = <Marker position={{ lat: props.point.lat, lng: props.point.lng }} icon={icon} pointId={props.point.id} zIndexOffset={zIndexOffset}>{popup}</Marker>;
        }

        return <>
            {isFeatureShown && feature}

            <ConfigurationDialog onCancel={() => setIsEditingSketchData(false)} show={isEditingSketchData} onSave={onSave} title="Edit Point">
                {props.sketch && props.sketch !== null && <RotationSlider value={rotate} onChange={setRotate} />}
            </ConfigurationDialog>

            <ConfigurationDialog show={isEditingFeature && !showApplyToModal} title="Edit Point" onCancel={onCancel} onSave={onSavePointAttributes} preventSave={arrayUtilities.isNullOrEmpty(featureTypes) || stringUtilities.isNullOrEmpty(selectedWorkflow)}>
                {
                    <EditMapFeature
                        formData={featureFormDataValues}
                        workflows={props.workflows}
                        selectedFeatureType={selectedFeatureType}
                        setSelectedFeatureType={setSelectedFeatureType}
                        selectedWorkflow={selectedWorkflow}
                        setSelectedWorkflow={setSelectedWorkflow}
                        featureTypes={featureTypes}
                        featureFormDataFields={featureFormDataFields}
                        setFeatureFormDataValues={setFeatureFormDataValues}
                        mixedValueFields={mixedValueFields}
                    />
                }
            </ConfigurationDialog>

            <Modal show={showApplyToModal} onHide={() => setShowApplyToModal(false)} centered>
                <Modal.Header>
                    <Modal.Title className="d-flex gap-2 align-items-center"><i className='fi-alert-triange text-warning' />Apply Changes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Apply these changes to just this point, or to all {linePointCount > 0 ? `${linePointCount} ` : ""}points on the {props.point.geometryType === 2 ? "Polygon" : "Line"}?</p>
                    <p className="m-0 text-danger">This cannot be undone.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button size="sm" variant='secondary' onClick={() => setShowApplyToModal(false)}>Cancel</Button>
                    <Button size="sm" variant='primary' onClick={() => savePointAttributes(false)}>Apply to just this point</Button>
                    <Button size="sm" variant='danger' onClick={() => savePointAttributes(true)}>Apply to all points</Button>
                </Modal.Footer>
            </Modal>

            <ConfigurationDialog show={isMovingData} title="Move Point" onCancel={onCancel} onSave={handleMoveData} preventSave={arrayUtilities.isNullOrEmpty(featureTypes) || stringUtilities.isNullOrEmpty(selectedJob)}>
                <MoveData
                    formData={featureFormDataValues}
                    projects={props.projects}
                    selectedProject={selectedProject}
                    onProjectChange={id => handleProjectChange(id)}
                    jobs={jobs}
                    selectedJob={selectedJob}
                    setSelectedJob={setSelectedJob}
                    workflows={workflowsByProject}
                    selectedWorkflow={selectedWorkflow}
                    setSelectedWorkflow={setSelectedWorkflow}
                    featureTypes={featureTypes}
                    selectedFeatureType={selectedFeatureType}
                    setSelectedFeatureType={setSelectedFeatureType}
                    featureFormDataFields={featureFormDataFields}
                    setFeatureFormDataValues={setFeatureFormDataValues}
                    isLoadingJobs={isLoadingJobs}
                    isLoadingWorkflows={isLoadingWorkflows}
                    onClickAddJob={() => setShowJobModal(true)} />
            </ConfigurationDialog>

            <Modal show={showJobModal} onCancel={() => setShowJobModal(false)} onHide={() => setShowJobModal(false)} onSave={() => { }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Job</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <SimpleBar autoHide={false} className='simplebar-no-autohide pe-3' style={{ maxHeight: 'calc(100vh - 380px)' }}>
                        <Form.Group className='mb-3 row'>
                            <Form.Label className='form-label fs-sm col-form-label col-md-3' htmlFor="job-name">
                                Name
                            </Form.Label>
                            <div className="col-md-9 d-flex align-items-center">
                                <Form.Control id="job-name" size='sm' value={newJobName} type="text" onChange={(e) => setNewJobName(e.target.value)} />
                            </div>
                        </Form.Group>
                    </SimpleBar>
                </Modal.Body>
                <Modal.Footer>
                    <div>
                        <Button size="sm" variant='secondary' onClick={() => {
                            setNewJobName("");
                            setShowJobModal(false);
                        }} className="me-2">Cancel</Button>
                        <Button size="sm" variant='primary' onClick={() => {
                            api.addJob(
                                props.organisationId, selectedProject, newJobName,
                                data => {
                                    setShowJobModal(false)
                                    api.getJobs(props.organisationId, selectedProject, result => setJobs(result), error => console.log(error))
                                    setSelectedJob(data.id)
                                    setNewJobName("");
                                }
                            )
                        }}>Save</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>;
    }

    return null;
}